import { Avatar as AntdAvatar, type AvatarProps } from 'antd'
import clsx from 'clsx'
import styles from './styles.module.scss'

export function Avatar({ className, ...props }: AvatarProps) {
  return <AntdAvatar className={clsx(className, styles.avatar)} {...props} />
}
